import React from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { validUUIDv4 } from "../../utils";
import { CONSUMER_SESSION_AUTH, ROUTE_PATHS, BRAND_GGV } from "../../constants";
import { Show404 } from "../404";

const LoginWithAuthLink = () => {
  const { phone, token, brand } = useParams();
  const history = useHistory();
  const location = useLocation();

  if (validUUIDv4(token)) {
    sessionStorage.setItem(
      CONSUMER_SESSION_AUTH,
      JSON.stringify({
        phone_number: phone,
        token: token
      })
    );

    const { search } = location;

    let pathname = ROUTE_PATHS.GGT.SCHEDULE_START;

    if (brand === BRAND_GGV) {
      pathname = ROUTE_PATHS.GGV.SCHEDULE_START;
    }

    history.push({ pathname, search });
  }

  return <Show404 />;
};

export { LoginWithAuthLink };
